var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main_div"}},[_c('About'),_vm._v(" "),_c('WhyUs'),_vm._v(" "),_c('Partners'),_vm._v(" "),_c('Team'),_vm._v(" "),_c('RecallForm'),_vm._v(" "),_c('Map'),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('js')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2311ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company_page.vue
// module id = null
// module chunks = 